/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightTravelerLoyaltyAccount } from './FlightTravelerLoyaltyAccount';
import {
    FlightTravelerLoyaltyAccountFromJSON,
    FlightTravelerLoyaltyAccountFromJSONTyped,
    FlightTravelerLoyaltyAccountToJSON,
    FlightTravelerLoyaltyAccountToJSONTyped,
} from './FlightTravelerLoyaltyAccount';

/**
 *
 * @export
 * @interface FlightBookingTraveler
 */
export interface FlightBookingTraveler {
    /**
     *
     * @type {string}
     * @memberof FlightBookingTraveler
     */
    travelerId: string;
    /**
     *
     * @type {string}
     * @memberof FlightBookingTraveler
     */
    type: FlightBookingTravelerTypeEnum;
    /**
     *
     * @type {string}
     * @memberof FlightBookingTraveler
     */
    givenName: string;
    /**
     *
     * @type {string}
     * @memberof FlightBookingTraveler
     */
    familyName: string;
    /**
     * Traveler birth calendar date as an origin-independent YYYY-MM-DD string.
     * @type {string}
     * @memberof FlightBookingTraveler
     */
    bornOn: string;
    /**
     *
     * @type {string}
     * @memberof FlightBookingTraveler
     */
    gender?: FlightBookingTravelerGenderEnum | null;
    /**
     *
     * @type {string}
     * @memberof FlightBookingTraveler
     */
    identityDocumentToken?: string | null;
    /**
     *
     * @type {Array<FlightTravelerLoyaltyAccount>}
     * @memberof FlightBookingTraveler
     */
    loyaltyAccounts?: Array<FlightTravelerLoyaltyAccount>;
}


/**
 * @export
 */
export const FlightBookingTravelerTypeEnum = {
    Adult: 'adult',
    Child: 'child',
    InfantWithoutSeat: 'infant_without_seat'
} as const;
export type FlightBookingTravelerTypeEnum = typeof FlightBookingTravelerTypeEnum[keyof typeof FlightBookingTravelerTypeEnum];

/**
 * @export
 */
export const FlightBookingTravelerGenderEnum = {
    Female: 'female',
    Male: 'male',
    Unspecified: 'unspecified'
} as const;
export type FlightBookingTravelerGenderEnum = typeof FlightBookingTravelerGenderEnum[keyof typeof FlightBookingTravelerGenderEnum];


/**
 * Check if a given object implements the FlightBookingTraveler interface.
 */
export function instanceOfFlightBookingTraveler(value: object): value is FlightBookingTraveler {
    if (!('travelerId' in value) || value['travelerId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('bornOn' in value) || value['bornOn'] === undefined) return false;
    return true;
}

export function FlightBookingTravelerFromJSON(json: any): FlightBookingTraveler {
    return FlightBookingTravelerFromJSONTyped(json, false);
}

export function FlightBookingTravelerFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightBookingTraveler {
    if (json == null) {
        return json;
    }
    return {

        'travelerId': json['traveler_id'],
        'type': json['type'],
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'bornOn': json['born_on'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'identityDocumentToken': json['identity_document_token'] == null ? undefined : json['identity_document_token'],
        'loyaltyAccounts': json['loyalty_accounts'] == null ? undefined : ((json['loyalty_accounts'] as Array<any>).map(FlightTravelerLoyaltyAccountFromJSON)),
    };
}

export function FlightBookingTravelerToJSON(json: any): FlightBookingTraveler {
    return FlightBookingTravelerToJSONTyped(json, false);
}

export function FlightBookingTravelerToJSONTyped(value?: FlightBookingTraveler | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'traveler_id': value['travelerId'],
        'type': value['type'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'born_on': value['bornOn'],
        'gender': value['gender'],
        'identity_document_token': value['identityDocumentToken'],
        'loyalty_accounts': value['loyaltyAccounts'] == null ? undefined : ((value['loyaltyAccounts'] as Array<any>).map(FlightTravelerLoyaltyAccountToJSON)),
    };
}
